import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Store } from "lucide-react";

const STORAGE_KEY = "cd_store_filter";

export function getActiveStore() {
  return localStorage.getItem(STORAGE_KEY) || "all";
}

export function StoreFilter({ value, onChange, compact = false, testid = "store-filter" }) {
  const [stores, setStores] = useState([]);

  useEffect(() => {
    api.get("/stores").then(({ data }) => setStores(data)).catch(() => setStores([]));
  }, []);

  const handle = (v) => {
    if (v === "all") localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, v);
    onChange?.(v);
  };

  return (
    <Select value={value || "all"} onValueChange={handle}>
      <SelectTrigger data-testid={testid} className={compact ? "h-9 w-48" : "w-56"}>
        <div className="flex items-center gap-2 min-w-0">
          <Store className="w-4 h-4 text-muted-foreground shrink-0" />
          <SelectValue placeholder="All stores" />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="store-all">All stores</SelectItem>
        {stores.map((s) => (
          <SelectItem key={s.name} value={s.name} data-testid={`store-opt-${s.name}`}>
            {s.name} <span className="text-xs text-muted-foreground ml-2">({s.count})</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
